/**
 * Configuration for DataDog RUM Session Replay
 *
 * This file contains the list of domains where session replay should be disabled.
 * Add customer domains here to disable session replay for those customers.
 */

export interface SessionReplayDomainBasedConfig {
  /** List of domains where session replay should be disabled */
  disabledDomains: string[];
  /** Default session replay sample rate for non-disabled domains */
  defaultSampleRate: number;
  /** Session replay sample rate for disabled domains (should be 0) */
  disabledSampleRate: number;
}

/**
 * Configuration for session replay control
 */
export const SESSION_REPLAY_CONFIG: SessionReplayDomainBasedConfig = {
  disabledDomains: ['disney.checkbox.ai'],
  defaultSampleRate: 20, // 20% of sessions have replay enabled
  disabledSampleRate: 0, // 0% of sessions have replay enabled
};

/**
 * Check if session replay should be disabled for the current domain
 */
export const isSessionReplayDisabled = (): boolean => {
  const currentHostname = window.location.hostname;

  return SESSION_REPLAY_CONFIG.disabledDomains.some(
    (domain) => currentHostname === domain
  );
};

/**
 * Get the appropriate session replay sample rate for the current domain
 */
export const getSessionReplaySampleRate = (): number =>
  isSessionReplayDisabled()
    ? SESSION_REPLAY_CONFIG.disabledSampleRate
    : SESSION_REPLAY_CONFIG.defaultSampleRate;
